<template>
  <section class="courseware-page">
    <audio ref="ref_audio" :src="currentVoiceUrl" @ended="overAudio" />
    <div class="loginout" @click="signOut">
      <SvgIcon class="exit" icon-class="exit" size="18px" />
    </div>
    <aside class="left-tree">
      <div class="cont" :class="{shrink: isCollapse}">
        <div class="logo-area">
          <img src="@/assets/images/logo-teacher-home.png">
          <div class="select">
            <el-select v-model="coursewareForm.materialId" size="mini" placeholder="请选择教材" style="width: 100%;" @change="selectChange">
              <el-option v-for="item in materialOptions" :key="item.id" :label="item.teachingName" :value="item.id" />
            </el-select>
          </div>
        </div>
        <leftNavTeacher :left-nav-list="leftTreeData" :default-active-id="coursewareForm.activeTreeId" @select="leftNavSelect" />
      </div>
      <div class="collapse-btn" @click="collapseClick">
        <img class="arrow" :class="{rotate: isCollapse}" src="@/assets/images/courseware/collapse-btn-arrow.png">
        <img src="@/assets/images/courseware/collapse-btn-logo.png">
      </div>
    </aside>
    <div class="right-content" :class="{shrink: isCollapse, isvideo: currentDataType === 'VIDEO'}">
      <!-- :class="{isGroup: currentDataType === 'SENTENCEPATTERNGROUP'}" -->
      <swiper
        v-show="coursewareForm.activeTreeId"
        ref="mySwiper"
        :options="swiperOptions"
        :auto-update="true"
        :auto-destroy="true"
        class="self-swiper"

        @slideChangeTransitionStart="onSwiperSlideChangeTransitionStart"
      >
        <swiper-slide v-for="(item, index) in detailData" :key="index" :class="{isSentence: isShowSentenceClass(item.meansType)}">
          <!-- <h3 v-if="currentDataType === 'SENTENCEPATTERNGROUP'" class="group-tit">{{ item.groupName }}</h3> -->
          <div class="pic-wraper">
            <!-- 视频类 -->
            <div v-if="item.meansType === '10'" class="watermark-video">
              <video ref="ref_video" oncontextmenu="return false;" controls="controls" controlsList="nodownload" :src="item.rootMouthShapePath" />
              <!-- <vue-core-video-player controls="auto" src="item.rootMouthShapePath"></vue-core-video-player> -->
              <!-- <vue-core-video-player controls="auto" src="https://media.vued.vanthink.cn/sparkle_your_name_am720p.mp4"></vue-core-video-player> -->
              <div class="watermarkDiv">
                {{ userInfo.fullName }} {{ phone }}
              </div>
            </div>
            <!-- 单词句型类 -->
            <div v-else class="watermark-container">
              <el-image :src="item.rootCardChartPath" fit="fit" />
              <div class="watermarkDiv">
                <span v-for="item2 in 12" :key="item2" class="txt">{{ userInfo.fullName }} {{ phone }}</span>
              </div>
            </div>

          </div>
          <div v-if="item.meansType !== '10'" class="word-name">
            <div class="txt">{{ item.wordName }}</div>
            <div class="voice-icon" @click="voiceClick(item, index)">
              <i
                :class="index === currentIndex ? 'suonaAnimation' : ''"
                class="suonaIcon"
              />
              <!-- <img src="@/assets/images/courseware/voice-icon.png"> -->
            </div>
          </div>
        </swiper-slide>

        <div slot="pagination" class="swiper-pagination" />
        <div slot="button-prev" class="swiper-button-prev" />
        <div slot="button-next" class="swiper-button-next" />
      </swiper>
      <div v-show="!coursewareForm.activeTreeId" class="empty-msg">
        当前教材暂无数据
      </div>
    </div>
  </section>
</template>

<script>
import leftNavTeacher from './components/leftNavTeacher.vue'
// import rejectLogin from './components/rejectLogin.vue'
import { selectTeatherShowMaterial, selectShowThemeData, selectShowTypeData, selectTeatherAndphone } from '@api/courseware/api_courseware'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
export default {
  components: {
    Swiper,
    SwiperSlide,
    leftNavTeacher
  },
  data() {
    return {
      userInfo: {},
      coursewareForm: {
        materialId: '',
        activeTreeId: ''
      },
      detailData: [],
      materialOptions: [],
      choosenId: '',
      leftTreeData: [],
      currentDataType: '',

      swiperOptions: {
        // 设置点击箭头
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        keyboard: true,
        spaceBetween: 100
        // loop: true
      },

      isSentence: true,
      isCollapse: false,
      currentIndex: -1,
      currentVoiceUrl: ''
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper
    },
    phone () {
      const len = this.userInfo.contactPhone.length
      return this.userInfo.contactPhone.substring(len - 4, len)
    }

  },
  watch: {

  },
  created() {
    this.fetchData()
  },
  mounted() {
    // document.querySelector('a:has(> img)')
    console.log(this.$refs.ref_video)
  },
  methods: {

    // 查询教材下拉框
    fetchData () {
      // 根据token 获取用户信息
      selectTeatherAndphone().then(res => {
        this.userInfo = res
      })

      // 查询教材下拉框
      selectTeatherShowMaterial().then(res => {
        this.materialOptions = res
        this.coursewareForm.materialId = res[0] ? res[0].id : ''
        this.selectChange(this.coursewareForm.materialId)
      }).catch(() => {
        this.$router.push('/coursewareTimeOut')
      })
    },

    // 根据教材查素材
    selectChange (val) {
      selectShowThemeData({ id: val }).then(res => {
        // 将没有素材的主题 过滤掉
        this.leftTreeData = res.filter(item => {
          return item.showBasicMeansList.length > 0
        })
        this.coursewareForm.activeTreeId = this.leftTreeData[0] ? this.leftTreeData[0].showBasicMeansList[0].id : ''

        // 教材下面 有主题，才请求展示素材详情
        if (this.coursewareForm.activeTreeId) {
          this.leftNavSelect(this.leftTreeData[0].showBasicMeansList[0])
        }
      })
    },
    // 根据素材查详情
    leftNavSelect (item) {
      this.currentDataType = item.basicCode
      selectShowTypeData({
        themeId: item.pid,
        basicCode: item.basicCode
      }).then(res => {
        this.detailData = res
        this.swiper.slideTo(0, 0, false)
        this.$nextTick(() => {
          if (this.currentDataType === 'VIDEO' && this.$refs.ref_video) {
            for (const item of this.$refs.ref_video) {
              item.disablePictureInPicture = true
            }
          }
        })
      }).catch(() => {
        this.$router.push('/coursewareTimeOut')
      })
    },
    // 轮播图滚动事件
    onSwiperSlideChangeTransitionStart () {
      const preIndex = this.swiper.previousIndex
      if (this.currentDataType === 'VIDEO') {
        this.$refs.ref_video[preIndex].pause()
      }
      this.$refs.ref_audio.pause()
    },

    isShowSentenceClass(type) {
      // 文件类型(1:高频词的单词、2:高频词的关联句型，3:自然拼读的音标资料、4:自然拼读的关联单词，5:单词的单词资料，6:句型资料,7 句型组资料，8:句型组句型资料 ,9 字母 10 视频 11 自定义
      if (type === '2' || type === '6' || type === '8') {
        return true
      } else {
        return false
      }
    },

    btnClick() {
      this.isCollapse = !this.isCollapse
    },

    overAudio () {
      this.currentIndex = -1
    },
    voiceClick (item, index) {
      this.currentIndex = index
      // this.currentVoiceUrl = item[key]
      this.currentVoiceUrl = item.rootPronunciationPath
      this.$nextTick(() => {
        this.$refs.ref_audio.load()
        this.$refs.ref_audio.play()
      })
    },
    collapseClick () {
      this.isCollapse = !this.isCollapse
      // this.swiper.update()
    },
    signOut () {
      this.$confirm('确认退出吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('LogOut')
      })
    }
  }
}
</script>

<style lang="scss">
.courseware-page {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  display: flex;
  .left-tree{
    background-color: #fff;
    flex-shrink: 0;
    position: relative;
    .cont{
      width: 260px;
      height: 100%;
      &.shrink{
        width: 0;
        overflow: hidden;
      }
      .el-menu{
        height: calc( 100% - 206px );
        overflow-y: auto;
        overflow-x: hidden;
      }
      .logo-area{
        position: relative;
        img{
          max-width: 100%;
        }
        .select{
          position: absolute;
          z-index: 10;
          bottom: 20px;
          width: 120px;
          height: 32px;
          left: 50%;
          transform: translateX(-50%);
          .el-input__inner{
            background-color: #FFE593;
            border-color: #FFE593;
            color: #53402B;
          }
          .el-icon-arrow-down:before, .el-icon-arrow-up:before {
            color: #53402B;
          }
        }
      }
    }
    .collapse-btn{
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      width: 106px;
      height: 90px;
      background: #FCDA6F;
      border-radius: 0px 45px 45px 0px;
      position: absolute;
      right: 0;
      bottom: 40px;
      margin-right: -106px;
      .arrow{
        margin-right: 5px;
        transition: all .3s;
        &.rotate{
          transform:rotate(180deg)
        }
      }
    }

  }
  .right-content{
    width: calc( 100% - 260px);
    flex: 1;
    background-color: #B0E098;
    display: flex;
    align-items: center;
    &.shrink{
      width: 100%;
    }
    .group-tit{
      font-family: 'Nunito-Black';
      font-size: 64px;
      color: #53402B;
      text-align: center;
      margin-bottom: 20px;
    }
    .self-swiper{
      width: 100%;
      margin: 0 170px;
      padding: 50px 0 70px 0;
      .pic-wraper{
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: rgba(255, 255, 255, 0.2);
        box-shadow: 0px 8px 24px #B0E098;
        margin-bottom: 40px;
        height: 640px;
        border-radius: 320px;

        .watermark-container{
          position: relative;
          width: 580px;
          height: 580px;
          overflow: hidden;
          .watermarkDiv{
            position: absolute;
            left:0; top:0;
            right: 0;bottom: 0;
            .txt{
              display: inline-block;
              color: #C3C2BF;
              opacity: 0.3;
              transform:rotate(-20deg);
              padding: 50px 65px 80px 40px;
            }
          }
        }
        .el-image{
          width:100%; height:100%;
          background-color: #fff;
          border-radius: 40px;
        }
      }
      .word-name{
        display: flex;
        justify-content: center;
        align-items: center;
        /*text-align: center;*/
        /*position: relative;*/
        margin-right: -130px;
        .txt{
          font-family: 'Nunito-Black';
          display: inline-block;
          text-align: center;
          width: 580px;
          height: 100px;
          line-height: 100px;
          background: #FFFFFF;
          box-shadow: 0px 6px 16px rgba(134, 203, 97, 0.25);
          border-radius: 20px;
          color: #53402B;
          font-size: 64px;
          font-weight: 900;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .voice-icon{
          /*position: absolute;
          right: 40px;
          top: 50%;
          transform: translate(0,-50%);*/
          display: inline-flex;
          width: 90px;
          height: 90px;
          background-color: #86CB61;
          box-shadow: 0px 4px 10px rgba(134, 203, 97, 0.5);
          border-radius: 50%;
          margin-left: 40px;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          transition: all 0.3s;
          &:hover{
            background-color: rgba(134, 203, 97, 0.8);
          }
          .suonaIcon{
            width: 43px;
            height: 34px;
            display: inline-block;
            background-image: url('./../../assets/images/courseware/voice-icon3.png');
            background-size: cover;
            &.suonaAnimation {
              animation: voiceAnimation 1s infinite;
            }
          }
          @keyframes voiceAnimation {
            0% {
              background-image: url('./../../assets/images/courseware/voice-icon1.png');
            }
            50% {
              background-image: url('./../../assets/images/courseware/voice-icon2.png');
            }
            100% {
              background-image: url('./../../assets/images/courseware/voice-icon3.png');
            }
          }
        }
      }
      .swiper-pagination-fraction, .swiper-pagination-custom, .swiper-container-horizontal > .swiper-pagination-bullets{
        bottom: 20px;
        color: #958778;
        font-weight: 900;
        font-size: 26px;
      }
    }

    .swiper-slide.isSentence{
      .pic-wraper{
        height: 540px;
        border-radius: 270px;

        .watermark-container{
          width: 480px;
          height: 480px;
          .watermarkDiv{
            .txt{
              padding: 50px 35px 55px 30px;
            }
          }
        }
        .el-image{
          border-radius: 30px;
        }
      }
      .word-name{
        /*margin-right: 0;*/
        .txt{
          width: calc( 100% - 400px);
          padding: 6px 15px;
          border-radius: 20px;
          font-size: 64px;
          height: auto;
          line-height: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          white-space: normal;
          /*text-align: left;*/
        }
      }
    }
    .swiper-button-prev:after, .swiper-container-rtl .swiper-button-next:after, .swiper-button-next:after, .swiper-container-rtl .swiper-button-prev:after{
      display: none;
    }
    .swiper-button-next, .swiper-button-prev{
      width: 110px;
      height: 110px;
      background-color: #F7AB00;
      box-shadow: 0px 4px 10px rgba(247, 171, 0, 0.5);
      border-radius: 50%;
      transition: all .3s;
      background-position: center;
      background-repeat: no-repeat;
      top: 39%;
    }
    .swiper-button-prev{
      left: 10%;
      background-image:url("./../../assets/images/courseware/arrow-left.png");
    }
    .swiper-button-next{
      right: 10%;
      background-image:url("./../../assets/images/courseware/arrow-right.png");
    }
  }
  .right-content.isvideo{
    .watermark-video{
      width:600px; height:337.5px;
      position: relative;

      video{
        width:100%; height:100%;
        border-radius: 20px;
      }

      .watermarkDiv{
        position: absolute;
        z-index: 99999;
        top: 30px;
        right: 30px;
        color: rgba(255, 255, 255, 0.5);
      }
    }
  }
  .empty-msg{
    width: 100%;
    color: #898884;
    text-align: center;
    font-size: 20px;
  }

  @media screen and (max-width: 1442px) {
    .left-tree{
      .cont{
        width: 200px;
        .el-menu{
          height: calc( 100% - 159px );
        }
      }
    }
    .right-content{
      width: calc( 100% - 200px);
      .group-tit{
        font-size: 40px;
      }
      .self-swiper{
        margin: 0 100px;
        padding: 50px 0 50px 0;
        .pic-wraper{
          box-shadow: 0px 8px 24px #B0E098;
          margin-bottom: 25px;
          height: 450px;
          border-radius: 225px;

          .watermark-container{
            width: 400px;
            height: 400px;
            .watermarkDiv{
              .txt{
                padding: 30px 30px 60px 15px;
              }
            }
          }
          .el-image{
            border-radius: 30px;
          }
        }
        .word-name{
          margin-right: -90px;
          .txt{
            width: 400px;
            height: 60px;
            line-height: 60px;
            border-radius: 15px;
            font-size: 48px;
          }
          .voice-icon{
            width: 60px;
            height: 60px;
            border-radius: 50%;
            margin-left: 30px;
            /*right: 90px;*/
            .suonaIcon{
              width: 33px;
              height: 26px;
            }
          }
        }
        .swiper-slide.isSentence{
          .pic-wraper{
            height: 400px;
            border-radius: 200px;

            .watermark-container{
              width: 350px;
              height: 350px;
              .watermarkDiv{
                .txt{
                  padding: 30px 10px 45px 15px;
                }
              }
            }
            .el-image{
              border-radius: 30px;
            }

          }
          .word-name{
            .txt{
              padding: 5px 10px;
              font-size: 48px;
            }
          }
        }
        .swiper-pagination-fraction, .swiper-pagination-custom, .swiper-container-horizontal > .swiper-pagination-bullets{
          bottom: 20px;
          font-size: 18px;
        }
      }
      .self-swiper.isGroup{
        padding: 30px 0 50px 0;
        .swiper-slide.isSentence{
          .pic-wraper{
            margin-bottom: 15px;
            height: 380px;
            border-radius: 190px;
            .watermark-container{
              width: 330px;
              height: 330px;
              .watermarkDiv{
                .txt{
                  padding: 30px 10px 40px 10px;
                }
              }
            }
          }
          .word-name{
            .txt{

              font-size: 40px;
            }
          }
        }
        .swiper-button-next, .swiper-button-prev{

          top: 42%;
        }
      }
      .swiper-button-next, .swiper-button-prev{
        width: 80px;
        height: 80px;
        background-size: 30% auto;
        top: 39%;
      }
    }
  }
  .loginout{
    position: fixed;
    top: 10px;
    right: 20px;
    padding: 10px;
    cursor: pointer;
    .exit{
      font-weight: 700;
      stroke-width: 15;
    }
  }
  video:focus{
    outline: -webkit-focus-ring-color auto 0px;
  }
  video::-internal-media-controls-download-button {
     display:none;
 }
 video::-webkit-media-controls-enclosure {
     overflow:hidden;
 }
 video::-webkit-media-controls-panel {
     width: calc(100% + 30px);
 }
}
</style>

